<main class="login-page">
  <section class="login-info-panel">
    <img class="login-logo" src="images/isg-governx-logo.png" alt="ISG GovernX" />

    <div class="login-info-content">
      <p class="login-eyebrow">Enterprise Governance</p>
      <h1 id="login-title" class="login-heading">
        Derive value, accelerate<br />performance,
        <em class="login-heading-highlight">Govern smarter</em>
      </h1>
      <p class="login-description">
        Gain real-time visibility across your vendor ecosystem with integrated governance,
        performance management, risk oversight, and financial controls powered by AI.
      </p>
    </div>

    <p class="login-footer">
      Terms of use - &copy; 2026 Information Services Group &ndash; All Rights Reserved
    </p>
  </section>

  <section class="login-action-panel" aria-labelledby="login-title">
    <div class="login-action-content">
      <p class="login-stat-value">$65B+</p>
      <p class="login-stat-caption">managed across over 5,000 client and vendor relationship</p>

      <div class="login-entry-actions">
        <isg-button
          class="login-action-button"
          [variant]="'primary'"
          [size]="'md'"
          [disabled]="false"
          [loading]="false"
          [fullWidth]="true"
          (click)="login()"
        >
          Login
        </isg-button>
      </div>
    </div>
  </section>
</main>
